import { withNamespaces } from 'react-i18next';

import { DocumentForensicsFilters, DocumentForensicsOutcomes } from '../../constants';

const DocumentsList = ({
    documents,
    filter,
    onFilterChange,
    onSelect,
    selectedDocumentId,
    t,
}) => {
    const counts = documents.reduce((result, document) => {
        result.all += 1;
        result[document.outcome] += 1;

        return result;
    }, {
        all: 0,
        needs_review: 0,
        rejected: 0,
        verified: 0,
    });

    const visibleDocuments = filter === 'all'
        ? documents
        : documents.filter((document) => document.outcome === filter);

    return (
        <div className="document-forensics-list">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h5 className="mb-0">
                    {t('Documents')}
                    <span className="badge badge-soft-secondary ms-2">{documents.length}</span>
                </h5>
            </div>

            <div className="d-flex flex-wrap gap-2 mb-3">
                {DocumentForensicsFilters.map((item) => (
                    <button
                        className={`document-forensics-filter is-${item.color} ${filter === item.key ? 'is-active' : ''}`}
                        key={item.key}
                        onClick={() => onFilterChange(item.key)}
                        type="button"
                    >
                        {`${t(item.title)} (${counts[item.key]})`}
                    </button>
                ))}
            </div>

            {visibleDocuments.map((document) => {
                const outcome = DocumentForensicsOutcomes[document.outcome];

                return (
                    <button
                        className={`document-forensics-item ${selectedDocumentId === document.id ? 'is-active' : ''}`}
                        key={document.id}
                        onClick={() => onSelect(document.id)}
                        type="button"
                    >
                        <img
                            alt={document.title}
                            className="document-forensics-thumb"
                            src={document.preview}
                        />
                        <span className="flex-grow-1 text-start">
                            <span className="d-block fw-medium">{t(document.title)}</span>
                            <span className="d-block text-muted font-size-12">
                                {`${document.fileFormat} · ${document.fileSize}`}
                            </span>
                            <span className="d-block text-muted font-size-12">
                                {`${t('Submitted')} ${document.submittedOn}`}
                            </span>
                        </span>
                        <span className={`${outcome.className} font-size-12 text-nowrap`}>
                            <i className={`${outcome.icon} align-middle me-1`} />
                            {t(outcome.title)}
                        </span>
                        <i className="ri-arrow-right-s-line text-muted" />
                    </button>
                );
            })}

            {!visibleDocuments.length && (
                <p className="text-muted text-center mb-0">{t('No documents found.')}</p>
            )}
        </div>
    );
};

export default withNamespaces()(DocumentsList);
